<div id="unity-container" class="unity-desktop">
    <canvas id="unity-canvas" tabindex="-1" class="fit-canvas"></canvas>
    <div id="unity-loading-bar">
        <div id="unity-logo"></div>
        <div id="unity-progress-bar-empty">
            <div id="unity-progress-bar-full"></div>
        </div>
    </div>
</div>